export default "__VITE_ASSET__BzqmgMP6__"